import smoothscroll from 'smoothscroll-polyfill';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export const initSliders = () => {
	let sliders = document.querySelectorAll('.slider__wrap');

	// Create slider instances
	sliders.forEach((slider) => {
		let isMobileSlider = slider.classList.contains('slider--mob')
			? true
			: false;

		let perView = 'auto';
		let centred = isMobileSlider ? true : false;
		let breakpoints = {
			// 300: {
			// 	slidesPerView: 1,
			// },
			// 768: {
			// 	slidesPerView: 2,
			// },
			// 992: {
			// 	slidesPerView: 1
			// },
		};

		let nav = {
			nextEl: '.slider__button.slider--next',
			prevEl: '.slider__button.slider--prev',
		};

		if (slider.classList.contains('slider--hide-nav')) {
		}

		// Init slider
		const swiper = new Swiper(slider, {
			preloadImages: true,
			touchRatio: 0.5,
			init: false,
			loop: false,
			navigation: nav,
			slidesPerView: perView,
			centeredSlides: centred,
			freeMode: false,
			breakpoints: breakpoints,
			spaceBetween: 20,
			// observer: true,
			// observeParents: true,
		});

		if (isMobileSlider && window.innerWidth <= 767) {
			swiper.init();
			// console.log('mobile')
		} else if (!isMobileSlider) {
			swiper.init();
			// console.log('not mobile')
		}
	});
};

export const linkScroll = () => {
	if (document.querySelector('.link--scroll')) {
		document
			.querySelector('.link--scroll')
			.addEventListener('click', function (e) {
				e.preventDefault();

				let scrollDist;
				let parent = this.closest('section');
				let currentScroll = window.scrollY;

				// if a parent section is found, scroll by the height of it
				// else scroll by the height of the viewport window
				if (parent) {
					scrollDist = parent.offsetHeight - currentScroll;
				} else {
					scrollDist = window.outerHeight - currentScroll;
				}

				// Support for all browsers
				smoothscroll.polyfill();

				// Perform scroll from current position
				window.scrollBy({
					top: scrollDist,
					behavior: 'smooth',
				});
			});
	}
};

// Find distance of element from viewport edges
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return {
		element: el,
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
	};
}

export const animate = () => {
	// Get all elements with an animation trigger
	let sections = document.querySelectorAll('[data-anim]');

	// General animation trigger loop
	function scrollEvents() {
		// Get current scroll distance
		let currentScroll = window.scrollY;

		sections.forEach((item) => {
			let itemDist = item.offsetTop;
			let trigger = itemDist - window.innerHeight * 0.66;
			let triggerEnd = itemDist + item.clientHeight;

			// Change trigger value for footer section
			if (item.nodeName == 'FOOTER') {
				let footerHeight = item.clientHeight;
				// Animation to trigger when user has scrolled half way through footer
				trigger =
					document.querySelector('main#wrapper').clientHeight -
					(window.innerHeight - footerHeight / 2);
				if (currentScroll >= trigger) {
					item.setAttribute('data-anim', true);
				}
			} else {
				if (currentScroll >= trigger && currentScroll < triggerEnd) {
					item.setAttribute('data-anim', true);
				}
			}
		});
	}

	// Trigger elements in view on load
	scrollEvents();

	// Listen for elements coming in to view
	window.addEventListener('scroll', function () {
		scrollEvents();
	});
	// Adjust on window resize
	window.addEventListener('resize', function () {
		scrollEvents();
	});
};

export const mobileMenu = () => {
	function toggleMobileMenu(event) {
		event.preventDefault();
		let active = document.body.classList.contains('mobile--active');
		if (active) {
			document.body.classList.add('mobile--closing');
			setTimeout(function () {
				document.body.classList.remove('mobile--active');
				document.body.classList.remove('mobile--closing');
			}, 500);
		} else {
			document.body.classList.add('mobile--active');
		}
	}

	let mobileToggle = document.querySelector('.mobile__toggle');
	if (mobileToggle) {
		mobileToggle.addEventListener('click', toggleMobileMenu);
	}
};

export const formValidation = () => {
	let form = document.querySelector('form.form--validation');

	if (form) {
		let errors = [];
		let inputs = form.querySelectorAll('[required]');

		form.onsubmit = function () {
			// Empty error array
			errors = [];
			inputs.forEach((input) => {
				input.classList.remove('field--error');
				if (!input.value) {
					errors.push(input);
					input.classList.add('field--error');
				}
			});

			// Halt submission if errors exist
			if (errors.length > 0) {
				event.preventDefault();
			}
		};
	}
};

export const header = () => {
	let lastScroll = 0;
	function headerActive(e, ignoreHide) {
		ignoreHide = ignoreHide ? ignoreHide : false;
		let currentScroll = window.scrollY;
		let header = document.querySelector('header#main');
		let body = document.body;

		// Add active class on scroll
		if (currentScroll >= header.clientHeight) {
			body.classList.add('header--active');
		} else {
			body.classList.remove('header--active');
		}

		if (!ignoreHide) {
			if (
				currentScroll >= lastScroll &&
				currentScroll > window.innerHeight
			) {
				document.body.classList.add('header--hide');
			} else {
				document.body.classList.remove('header--hide');
			}
		}

		lastScroll = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
	}

	addEventListener('scroll', headerActive);
	headerActive(this, true);
};

export const credit = () => {
	
};

export const initAccordions = () => {
	let accordions = document.querySelectorAll('.accordion');

	// Apply to all instances of accordion
	accordions.forEach((accordion) => {
		let entries = accordion.querySelectorAll('.accordion__entry');

		entries.forEach((entry) => {
			// Run on click
			entry.addEventListener('click', function () {
				entry.classList.toggle('item--active');
			});
		});
	});
};

export const initModals = () => {
  const openModal = (id) => {
    const modal =
      document.querySelector(`[data-modal="${id}"]`) ||
      document.getElementById(id);
    if (!modal) return;
    modal.classList.add('modal--active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('header--hide');
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('modal--active');
    modal.setAttribute('aria-hidden', 'true');
    // remove header--hide only if no modals are open
    if (!document.querySelector('[data-modal].modal--active')) {
      document.body.classList.remove('header--hide');
    }
  };

  // Event delegation for open/close clicks
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-target]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.dataset.modalTarget);
      return;
    }

    const closer = e.target.closest('[data-modal-close]');
    if (closer) {
      e.preventDefault();
      closeModal(closer.closest('[data-modal]'));
      return;
    }

    if (e.target.classList && e.target.classList.contains('modal__overlay')) {
      closeModal(e.target.closest('[data-modal]'));
    }
  });

  // ESC key closes any open modal
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document
        .querySelectorAll('[data-modal].modal--active')
        .forEach((m) => closeModal(m));
    }
  });
};